import React, {Component} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';

import css from 'css';

import Container from 'partials/Container';
import RemoveIcon from 'images/RemoveIcon';
import { gtmPush } from 'helpers';

import {
    setCheckoutVisibility,
    resetCheckout,
    resetCheckoutOpportunity,
    setChatVerticalPadding,
    resetChat,
    setCheckoutStep
} from 'store';
import {cookie} from "../../../helpers";

const CartBar = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px 0;
    color: #FFFFFF;
    background: ${css.colors.blue};
`;

const Description = styled.div`
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    .text {
        margin: 15px;

        b {
            font-weight: bold;
        }
    }

    .icon {
        display: table;
        width: 36px;
        height: 36px;
        background-color: white;
        border-radius: 50%;

        .value {
            text-align: center;
            top: 7px;
            color: #000000;
        }
    }
`;

const Button = styled.button`
    position: relative;
    color: #FFFFFF;
    cursor: pointer;
`;

class MobileCart extends Component {

    constructor() {
        super();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.opportunity.courses != this.props.opportunity.courses) {
            if (prevProps.opportunity.courses.length > 0) {
                cookie.set('shoppingCartTimeScheduleAutumn', '', 1);
                cookie.set('shoppingCartTimeScheduleSpring', '', 1);
            }
        }
        if (!this._showCart()) {
            this.props.resetChat();
        }
        this.props.setChatVerticalPadding(90);
    }

    _openCheckout() {
        this.props.setCheckoutVisibility(true);

        this.props.resetChat();

        gtmPush({
            'event': 'GAEvent',  
            'eventCategory': 'checkout',  
            'eventAction': 'open',  
            'eventLabel': 'Open Checkout',  
            'eventValue': 20,  
            'nonInteraction': false
        });
    }

    _cancelCheckout() {
        this.props.resetCheckout();
        this._removeCookie();
        this.props.resetCheckoutOpportunity();
    }

    _removeCookie(){
        if (cookie.get('shoppingCart')) {
            cookie.set('shoppingCart', JSON.stringify([]), 1);
        }
    }

    _showCart() {
        const {courses, programs} = this.props.opportunity;
        return courses.length + programs.length > 0;
    }

    render() {
        const {courses, programs} = this.props.opportunity;

        return !this._showCart() ? (
            null
        ) : (
            <CartBar>
                <Container flex align="center" justify="space-between">
                <Button onClick={this._cancelCheckout.bind(this)}>
                        Avbryt <RemoveIcon color="#fff" />
                    </Button>
                    <Description onClick={this._openCheckout.bind(this)}>
                        <div className="icon">
                            <div className="value"> {courses.length + programs.length} </div>
                        </div>
                        <div className="text">
                            Se listen din &rarr;
                        </div>
                    </Description>
                </Container>
            </CartBar>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
});

const actions = {
    setCheckoutVisibility,
    resetCheckout,
    resetCheckoutOpportunity,
    setChatVerticalPadding,
    resetChat,
    setCheckoutStep
}

export default connect(mapStateToProps, actions)(MobileCart);


// WEBPACK FOOTER //
// ./src/partials/shared/Cart/MobileCart.js